/** Zijrail met dagvoortgang, streak en planstats voor Today (triage-hero staat los). */
import { Box } from '@mui/material';
import { PlanRailStats } from '@/features/planning/components/shared/PlanRailStats';
import DayProgressDots from './DayProgressDots';
import CompletionStreak from './CompletionStreak';

const TodayStatsRail = ({ allTasks, tasksMap, sx }) => (
  <Box data-testid="today-stats-rail" sx={sx}>
    {/* Read-only stats: inert keeps them out of tab order without blocking clicks on links below. */}
    <Box inert>
      <DayProgressDots />
      <CompletionStreak />
    </Box>
    <PlanRailStats
      allTasks={allTasks}
      tasksMap={tasksMap}
      showMetadata={false}
    />
  </Box>
);

export default TodayStatsRail;
